import React from "react";
import "./Spinner.css";

export default function Spinner() {
  return <div className="custom_loader "></div>;
}
